const Rolesmodule = [
  {
    id: 1,
    module: "Staff",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 2,
    module: "Lead",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: true,
  },
  // {
  //   id: 3,
  //   module: "Marketing - Opportunity",
  //   view: 0,
  //   viewGlobal: 0,
  //   add: 0,
  //   edit: 0,
  //   delete: 0,
  //   isAdd: true,
  //   isEdit: true,
  //   isDelete: true,
  //   isViewGlobal: false,
  // },
  {
    id: 4,
    module: "Cold Calling",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: true,
  },
  {
    id: 12,
    module: "Payroll - Employee Expenses",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 13,
    module: "Payroll - Employee Advance",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 14,
    module: "Payroll - Punch Details",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 5,
    module: "Payroll - Salary",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 6,
    module: "Payroll - Slip",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 7,
    module: "Location Tracking",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 8,
    module: "Leave Management - Leave",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
    isViewGlobal: false,
  },
  {
    id: 9,
    module: "Leave Management - Holiday",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 10,
    module: "Settings - Roles",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 11,
    module: "Settings - Allowances",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
    isViewGlobal: false,
  },
  // New modules are appended: saved roles are matched to this list by position.
  {
    id: 15,
    module: "Task Management",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 16,
    module: "Settings - Task Status",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 17,
    module: "Settings - Departments",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
  {
    id: 18,
    module: "Settings - Priorities",
    view: 0,
    viewGlobal: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
    isViewGlobal: false,
  },
]

export default Rolesmodule
